import ReviewApproval from "features/approve-review";
import BlogsNews from "features/blogs-news";
import FooterSeo from "features/footer-seo";
import Categories from "features/categories";
import MainDashboard from "features/main-dashboard";
import Orders from "features/orders";
import PartnerApproval from "features/partner-approval";
import Product from "features/product";

import {
  MdHome,
  MdNewspaper,
  MdOutlineCategory,
  MdOutlineList,
  MdOutlinePerson,
  MdOutlineShoppingCart,
  MdOutlineStars,
} from "react-icons/md";
import { RiSeoLine } from "react-icons/ri";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Product",
    layout: "/admin",
    path: "product",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <Product />,
  },
  {
    name: "Categories",
    layout: "/admin",
    path: "category",
    icon: <MdOutlineCategory className="h-6 w-6" />,
    component: <Categories />,
  },
  {
    name: "Partner Approval",
    layout: "/admin",
    path: "partner-approval",
    icon: <MdOutlinePerson className="h-6 w-6" />,
    component: <PartnerApproval />,
  },
  {
    name: "Orders",
    layout: "/admin",
    path: "orders",
    icon: <MdOutlineList className="h-6 w-6" />,
    component: <Orders />,
  },
  {
    name: "Approve Review",
    layout: "/admin",
    path: "approve-review",
    icon: <MdOutlineStars className="h-6 w-6" />,
    component: <ReviewApproval />,
  },
  {
    name: "Blogs & News",
    layout: "/admin",
    path: "blog-news",
    icon: <MdNewspaper className="h-6 w-6" />,
    component: <BlogsNews />,
  },
  {
    name: "Footer SEO",
    layout: "/admin",
    path: "footer-seo",
    icon: <RiSeoLine className="h-6 w-6" />,
    component: <FooterSeo />,
  },
];

export default routes;
